import gql from 'graphql-tag';

export const getGoalComments = gql`
  query GetGoalComments($userID: String!, $goalID: String!) {
    getGoalComments(userID: $userID, goalID: $goalID) {
      userName
      timestamp
      comment
      commentID
    }
  }
`;
